/* Collapsible rows (03 rows + 08 FAQ). Closed on load, <button aria-expanded aria-controls>, +/- icon, 200ms height
   transition (instant with reduced motion). data-mode="independent" (default) or "single" (one open at a time). */
(() => {
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setOpen(item, open) {
    const btn = item.querySelector('[data-sm-acc-trigger]');
    const panel = item.querySelector('[data-sm-acc-panel]');
    if (!btn || !panel) return;
    const isOpen = btn.getAttribute('aria-expanded') === 'true';
    if (isOpen === open) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    item.classList.toggle('open', open);
    if (reduce()) { panel.hidden = !open; panel.style.height = ''; return; }
    panel.classList.add('is-animating');
    if (open) {
      panel.hidden = false;
      panel.style.height = '0px';
      const h = panel.scrollHeight;
      requestAnimationFrame(() => { panel.style.height = h + 'px'; });
    } else {
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(() => requestAnimationFrame(() => { panel.style.height = '0px'; }));
    }
    const done = (e) => {
      if (e && e.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', done);
      panel.classList.remove('is-animating');
      panel.style.height = '';
      if (btn.getAttribute('aria-expanded') !== 'true') panel.hidden = true;
    };
    panel.addEventListener('transitionend', done);
    setTimeout(() => done(), 320);
  }
  function init(root) {
    if (root.dataset.smAccReady) return;
    root.dataset.smAccReady = '1';
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-sm-acc-trigger]');
      if (!btn || !root.contains(btn)) return;
      const item = btn.closest('[data-sm-acc-item]');
      const open = btn.getAttribute('aria-expanded') !== 'true';
      if (open && root.dataset.mode === 'single') {
        root.querySelectorAll('[data-sm-acc-item]').forEach((other) => { if (other !== item) setOpen(other, false); });
      }
      setOpen(item, open);
    });
  }
  const run = () => document.querySelectorAll('[data-sm-accordion]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:block:select', (e) => {
    const item = e.target.closest && e.target.closest('[data-sm-acc-item]');
    if (item) setOpen(item, true);
  });
  window.SM = window.SM || {};
  window.SM.accordionSetOpen = setOpen;
})();
